import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export default function FloatingSupportWidget() {
  const [showDialog, setShowDialog] = useState(false);

  const handleSupport = () => {
    // Open BMC link in new tab
    window.open('https://buymeacoffee.com/paulofhreik?utm_source=app_widget', '_blank');
    setShowDialog(false);
  };

  const handleFloatingClick = () => {
    setShowDialog(true);
  };

  return (
    <>
      {/* Floating Support Button */}
      <Button
        onClick={handleFloatingClick}
        size="icon"
        className="fixed bottom-5 right-5 z-[80] h-14 w-14 rounded-full shadow-lg hover:shadow-xl pointer-events-auto bg-[#FFDD00] hover:bg-[#FFDD00]/90 text-black"
        aria-label="Support DesignStack"
      >
        <span className="text-2xl">☕</span>
      </Button>

      {/* Support Dialog */}
      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <span>☕</span>
              Support DesignStack
            </DialogTitle>
            <DialogDescription>
              Help keep DesignStack running and growing! Your support means the world to us.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <Button 
              onClick={handleSupport}
              className="w-full bg-[#FFDD00] hover:bg-[#FFDD00]/90 text-black font-medium"
            >
              <span className="mr-2">☕</span>
              Support DesignStack
              <span className="ml-2">↗</span>
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}